function NullFile() {
  return <div>No</div>;
}
export default NullFile;
